<template>
  <nav
    :class="[
      'fixed top-0 w-full z-50 py-3 px-3 lg:px-8 transition-all duration-300 max-w-[2560px]',
      computedNavClass,
    ]"
  >
    <!-- Mobile Menu Toggle -->

    <div class="flex items-center justify-between">
      <!-- Left Section: Menu Button and Logo -->
      <div class="flex items-center">
        <!-- Mobile Menu Button -->
        <button @click="toggleMobileMenu" class="mr-4 md:hidden">
          <svg
            v-if="!mobileMenuOpen"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <!-- Company Logo -->
        <div class="text-xl font-semibold">
          <a href="/">
            <img
              src="../assets/pictures/tbtlogo.png"
              alt="TURBO TECH"
              class="h-8 w-auto inline-block"
            />
          </a>
        </div>
      </div>

      <!-- Center Section: Navigation Links -->
      <ul class="hidden md:flex space-x-8 text-sm">
        <li
          v-for="link in navigationLink"
          :key="link.id"
          class="relative group"
        >
          <router-link
            v-if="link.name_en !== 'Our Services'"
            :to="link.url"
            class="hover:text-tbt-blue transition-all"
          >
            {{ getLocalized(link, "name") }}
          </router-link>

          <!-- Dropdown for "Our Services" -->
          <div v-else class="relative">
            <router-link
              to="/services"
              class="hover:text-tbt-blue transition-all flex items-center"
            >
              {{ getLocalized(link, "name") }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 ml-1 hidden lg:block"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </router-link>

            <div
              class="absolute left-0 w-56 pt-4 z-20 opacity-0 invisible group-hover:opacity-100 group-hover:visible hidden lg:block"
            >
              <ul
                :class="[
                  'shadow-lg rounded-lg text-black py-2 border border-gray-100',
                  !isScrolled
                    ? 'bg-none text-white backdrop-blur-sm bg-black bg-opacity-50 border-gray-100'
                    : 'bg-white',
                ]"
              >
                <li
                  v-for="(item, index) in subServiceLink"
                  :key="index"
                  class="py-2 px-4 hover:bg-tbt-blue hover:text-white transition-all duration-300 cursor-pointer"
                >
                  <router-link :to="item.url" class="block w-full">
                    {{ getLocalized(item, "name") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>

      <!-- Right Section: Contact Us -->
      <div class="flex gap-[30px] items-center cursor-pointer">
        <!-- Change -->
        <span @click="changeLanguage()">
          <img
            class="w-[44px] h-[28px]"
            :src="currentLang === 'en' ? cflag : uflag"
          />
        </span>
        <a
          href="/contact-us"
          class="rounded-[60px] bg-tbt-blue px-[10px] hidden lg:block md:px-[20px] py-[10px] md:py-[12px] text-sm font-medium text-white hover:scale-105 transition-transform"
        >
          {{ getLocalized1("btn") }}
        </a>
      </div>
    </div>

    <!-- Mobile Sidebar Overlay -->
    <div
      :class="[
        'fixed inset-0 bg-black bg-opacity-50 z-40 transition-all duration-300',
        mobileMenuOpen ? 'visible opacity-100' : 'invisible opacity-0',
      ]"
      @click="toggleMobileMenu"
      aria-hidden="true"
    ></div>

    <!-- Mobile Sidebar -->
    <div
      :class="[
        'fixed top-0 left-0 z-50 bg-white h-full w-[280px] p-4 shadow-lg transition-transform transform ease-in-out duration-300 text-black',
        mobileMenuOpen ? 'translate-x-0' : '-translate-x-full',
      ]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mobile-menu-title"
    >
      <div class="flex justify-between items-center mb-8">
        <img src="../assets/pictures/tbtlogo.png" alt="" />
      </div>
      <!-- Navigation Links -->
      <nav>
        <ul class="space-y-4">
          <li v-for="link in mobileNavBar" :key="link.id">
            <router-link
              :to="link.url"
              class="block text-base py-2 hover:text-tbt-blue transition-colors"
              @click="toggleMobileMenu"
            >
              {{ getLocalized(link, "name") }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </nav>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
import cflag from "../assets/pictures/cflag.png";
import uflag from "../assets/pictures/english.svg";
export default {
  props: {
    hasNoBg: { Boolean, require: true },
  },
  computed: {
    computedNavClass() {
      if (this.$route.path === "/services") {
        return this.isScrolled
          ? "bg-white text-black"
          : this.hasNoBg
          ? "text-white"
          : "text-black";
      }
      return this.isScrolled || this.isServicesHovered
        ? "bg-white text-black"
        : this.hasNoBg
        ? "text-black bg-white"
        : "text-white";
    },
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false,
      isServicesHovered: false,
      api: process.env.VUE_APP_API_KEY,
      navigationLink: [],
      subServiceLink: [],
      mobileNavBar: [],
      currentLang: localStorage.getItem("language") || "en", // Check stored language
      cflag: cflag,
      uflag: uflag,
      translations: {
        btn: {
          en: "Contact Us ",
          kh: "ទំនាក់ទំនងមកយើង",
        },
      },
    };
  },

  watch: {
    // Watch for changes in currentLang and store it in localStorage
    currentLang(newLang) {
      localStorage.setItem("language", newLang); // Store the updated language
    },
  },

  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    changeLanguage() {
      this.currentLang = this.currentLang === "en" ? "kh" : "en";
      this.updateFont(this.currentLang); // Apply the font change immediately
      localStorage.setItem("language", this.currentLang); // Store the updated language
      window.location.reload();
    },

    async fetchNavigation() {
      try {
        const response = await axios.get(this.api + "/api/menus");
        this.navigationLink = response.data.items.filter(
          (item) => item.name_en !== "Contact Us" || item.url !== "/contact-us"
        );
        this.navigationLink.sort((a, b) => a.display_order - b.display_order);

        // Mobile navbar Fetch
        this.mobileNavBar = response.data.items;
        this.mobileNavBar.sort((a, b) => a.display_order - b.display_order);

        const responseSubService = await axios.get(this.api + "/api/submenus");
        this.subServiceLink = responseSubService.data.items;
        this.subServiceLink.sort((a, b) => a.display_order - b.display_order);
      } catch (e) {
        console.error(e.message);
      }
    },
    updateFont(lang) {
      const body = document.body;
      if (lang === "kh") {
        body.style.fontFamily = "'Kantumruy Pro', sans-serif"; // Khmer font
      } else if (lang === "en") {
        body.style.fontFamily = "'Roboto', sans-serif"; // Default font
      } else {
        body.style.fontFamily = "'Roboto', sans-serif"; // Default font
      }
    },
  },
  mounted() {
    this.fetchNavigation();
    window.addEventListener("scroll", this.handleScroll);
    this.updateFont(this.currentLang); // Apply font change on page load
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
